var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 79,
    viewBox: "0 0 66 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5621",
    d: "M33.5879 0.524902H58.5582L25.2644 47.7858H0.294128L33.5879 0.524902Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 5622",
    d: "M40.2378 31.4893H65.2082L31.9144 78.7502H6.94409L40.2378 31.4893Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBars);
export default __webpack_public_path__ + "static/media/logo-bars.7a0b7d134b78c5f094945cefac94d5ae.svg";
export { ForwardRef as ReactComponent };